import React from 'react';
import { auth } from '../firebase';
import { signOut } from 'firebase/auth';

function Header({ messageCount, user }) {
  const handleSignOut = () => signOut(auth);

  return (
    <header className="app-header">
      <div className="header-brand">
        <div className="logo-badge">
          <img src={process.env.PUBLIC_URL + '/logo192.png'} alt="RhytoLeaf logo" className="header-logo" />
        </div>
        <div className="brand-text">
          <span className="brand-title">RhytoLeaf</span>
          <span className="brand-sub">Superchat</span>
        </div>
      </div>

      {messageCount != null && (
        <span className="message-count">{messageCount} messages</span>
      )}

      {user && (
        <button className="sign-out-btn" onClick={handleSignOut}>
          Sign Out
        </button>
      )}
    </header>
  );
}

export default Header;
